import { FETCH_WORKOUT_BY_ID_FINISHED } from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    workoutSteps: [],
    isFetching: false
};

const workoutByIdFetchFinished = (state, action) => {
    return {
        ...state,
        workoutSteps: parseStepData(action.workoutById.workoutSegments[0].workoutSteps),
        isFetching: false
    };
};

function parseStepData(stepsList) {
    let steps = [];

    if (stepsList) {
        for (let i = 0, length = stepsList.length; i < length; i++) {
            // Recursively go over all the repeat blocks
            if (stepsList[i].type === 'RepeatGroupDTO') {
                steps.push(...parseStepData(stepsList[i].workoutSteps));
            }
            // Add each workout step's URL fragment
            else if (stepsList[i].type === 'ExecutableStepDTO') {
                stepsList[i].exerciseName = stepsList[i].exerciseName || stepsList[i].category;
                // rest steps have both exerciseName and category as null or undefined
                const isRestStep =
                    [null, undefined].includes(stepsList[i].category) &&
                    [null, undefined].includes(stepsList[i].exerciseName);
                if (!isRestStep) {
                    const url = stepsList[i].category + '/' + stepsList[i].exerciseName;
                    steps.push({
                        url: url,
                        stepOrder: stepsList[i].stepOrder
                    });
                }
            }
        }
    }

    return steps;
}

const handlers = {
    [FETCH_WORKOUT_BY_ID_FINISHED]: workoutByIdFetchFinished
};

export const getWorkoutSteps = (state) => {
    return state.workoutSteps;
};

export default function workoutSteps(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
